import React, { useState } from 'react';
import { Plus, FileText } from 'lucide-react';
import { ReportIssueModal } from './ReportIssueModal';
interface QuickActionsProps {
  onNewBooking?: () => void;
}
export function QuickActions({
  onNewBooking
}: QuickActionsProps) {
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const actions = [{
    label: 'New Booking',
    icon: Plus,
    primary: true,
    onClick: onNewBooking
  }, {
    label: 'Report Issue',
    icon: FileText,
    primary: false,
    onClick: () => setIsReportModalOpen(true)
  }];
  return <>
      <div className="flex flex-wrap gap-3" data-id="element-318">
        {actions.map(action => <button key={action.label} onClick={action.onClick} className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-colors ${action.primary ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'}`} data-id="element-319">
            <action.icon className="w-4 h-4" data-id="element-320" />
            {action.label}
          </button>)}
      </div>

      <ReportIssueModal isOpen={isReportModalOpen} onClose={() => setIsReportModalOpen(false)} data-id="element-321" />
    </>;
}